import React from 'react'
import { useDrop } from 'react-dnd'

const Droppable = React.forwardRef(
  (
    {
      item,
      enabled = true,
      className = '',
      style = {},
      events = {},
      children,
      onDrop
    },
    ref
  ) => {
    const [{ isOver }, drop] = useDrop({
      accept: item.type,
      drop: onDrop,
      collect: (monitor) => ({
        isOver: !!monitor.isOver({ shallow: true })
      })
    })

    return (
      <div
        ref={(elem) => {
          if (ref) ref(elem)
          if (enabled) drop(elem)
        }}
        {...{ className, style, ...events }}
      >
        {typeof children === 'function' ? children(isOver) : children}
      </div>
    )
  }
)
Droppable.displayName = 'Droppable'
export default Droppable
